import { z } from 'zod';
import {
  MAX_ACCURACY_METERS,
  MAX_SITE_RADIUS,
  MIN_SITE_RADIUS,
} from './worksites.js';

/** مخططات مواقع العمل وتسجيل الحضور. */

const lat = z.coerce
  .number()
  .min(-90, 'خط العرض خارج المدى.')
  .max(90, 'خط العرض خارج المدى.');

const lng = z.coerce
  .number()
  .min(-180, 'خط الطول خارج المدى.')
  .max(180, 'خط الطول خارج المدى.');

export const UpsertWorkSiteSchema = z.object({
  name: z.string().trim().min(2, 'اسم الموقع قصير.').max(120),
  address: z
    .string()
    .trim()
    .max(300)
    .transform((v) => (v === '' ? null : v))
    .nullable()
    .optional(),
  lat,
  lng,
  radiusMeters: z.coerce
    .number()
    .int()
    .min(MIN_SITE_RADIUS, `نصف القطر أقلّ من ${MIN_SITE_RADIUS} مترًا.`)
    .max(MAX_SITE_RADIUS, `نصف القطر أكبر من ${MAX_SITE_RADIUS} مترًا.`)
    .default(200),
  isActive: z.boolean().default(true),
});
export type UpsertWorkSiteInput = z.infer<typeof UpsertWorkSiteSchema>;

/**
 * نقطةُ الموظّف لحظةَ التسجيل.
 *
 * الدقّةُ مطلوبةٌ لا اختيارية: بلا معرفةِ خطأ القياس لا يُعرف هل «داخل
 * النطاق» تعني داخله فعلًا أم أنّ المتصفّح خمّن من عنوان الإنترنت. وما
 * يُرسَل يُعاد حسابُه في الخادم على كلّ حال — الرقمُ هنا يكتبه من شاء.
 */
export const CheckPointSchema = z.object({
  lat,
  lng,
  accuracy: z.coerce
    .number()
    .min(0)
    .max(100_000, 'دقّة التحديد خارج المدى.')
    .default(MAX_ACCURACY_METERS),
  note: z
    .string()
    .trim()
    .max(500)
    .transform((v) => (v === '' ? null : v))
    .nullable()
    .optional(),
});
export type CheckPointInput = z.infer<typeof CheckPointSchema>;
